import React, { useState, useEffect, useCallback } from 'react';
import PageContentWrapper from '../../pages/components/pageContentWrapper';
import { getAgent, updateAndGetAgent } from '../../service/userService';
import { AgentSettingsForm } from './AgentSettingsForm';
import { User } from '../../types/user';
import { setHelpPage, setWindowTitle } from '../../configTdm';

interface Props {}

interface State {
  loading: boolean;
  errorMessage?: string;
  agent?: User;
}

const errors = {
  getUser: {
    backendFailure: 'Failed to get user. Please try again.',
  },
  updateUserSetting: {
    backendFailure: 'Failed to update user settings. Please try again.',
  },
};

const AgentSettingsContainer: React.FC<Props> = () => {
  const [state, setState] = useState<State>({
    loading: false,
    errorMessage: undefined,
    agent: undefined,
  });

  useEffect(() => {
    setWindowTitle('Agent Settings');
    setHelpPage('helpAdmin');
    setState(prevState => ({ ...prevState, loading: true }));
    getAgent()
      .then(agent => {
        setState(prevState => ({ ...prevState, agent }));
      })
      .catch(() => {
        setState(prevState => ({ ...prevState, errorMessage: errors.getUser.backendFailure }));
      })
      .finally(() => {
        setState(prevState => ({ ...prevState, loading: false }));
      });
  }, []);

  const handleFormSubmit = useCallback((email: string): void => {
    setState(prevState => ({ ...prevState, loading: true }));
    updateAndGetAgent(email)
      .then(agent => {
        setState(prevState => ({ ...prevState, agent }));
      })
      .catch(() => {
        setState(prevState => ({ ...prevState, errorMessage: errors.updateUserSetting.backendFailure }));
      })
      .finally(() => {
        setState(prevState => ({ ...prevState, loading: false }));
      });
  }, []);

  return (
    <PageContentWrapper loading={state.loading} title="USER SETTINGS">
      {state.agent && (
        <AgentSettingsForm
          email={state.agent.email}
          errorMessage={state.errorMessage}
          onSave={handleFormSubmit}
        />
      )}
    </PageContentWrapper>
  );
};

export default AgentSettingsContainer;
